import { HttpClient } from '@angular/common/http'
import { inject } from '@angular/core'
import { StorybookTranslationsService } from '@bonduelle-it/storybook'
import { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import { catchError, defer, forkJoin, from, map, Observable, of } from 'rxjs'

export class TranslationsLoader implements TranslateLoader {
  private sbTranslations = inject(StorybookTranslationsService)
  private http = inject(HttpClient)

  getTranslation(lang: string): Observable<TranslationObject> {
    const loadApp = (l: string) =>
      this.http
        .get(`assets/i18n/${l}.json`)
        .pipe(catchError(() => this.http.get(`assets/i18n/en-us.json`).pipe(catchError(() => of({})))))

    const loadStorybook = (l: string) =>
      defer(() => from(this.sbTranslations.load(l))).pipe(catchError(() => from(this.sbTranslations.load('en-us'))))

    return forkJoin({
      app: loadApp(lang),
      storybook: loadStorybook(lang),
    }).pipe(map(({ app, storybook }) => ({ ...storybook, ...app })))
  }
}
